import { Component } from "@angular/core";
import { SafeHtml, DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: "product-description",
    templateUrl: "./product-description.component.html",
    styleUrls: ["./product-description.component.less"]
})
export class ProductDescriptionComponent {
    description: SafeHtml;
    descriptionPresent: boolean;
    title: SafeHtml;
    titlePresent: boolean;

    constructor(private sanitizer: DomSanitizer) { }

    setDescription(description: string): void {
        if (description === "") {
            this.descriptionPresent = false;
        } else {
            this.description = this.sanitizer.bypassSecurityTrustHtml(description);
            this.descriptionPresent = true;
        }
    }

    setTitle(title: string): void {
        if (title === "") {
            this.titlePresent = false;
        } else {
            this.title = this.sanitizer.bypassSecurityTrustHtml(title);
            this.titlePresent = true;
        }
    }
}
